import { FilterSection } from '../../features/filter/types'

export const findUncheckedDealerInFilters = (
  dealersSections: FilterSection | undefined,
  filterByDealers: (string | number)[]
): string => {
  return (
    dealersSections?.groups // @ts-ignore
      .flatMap((group) => group.fields)
      .map((field) => field.value)
      .find((value) => !filterByDealers.includes(value || '')) || ''
  )
}
